import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PageSection } from '@gik/ui';
import BenefitsListGrid from './BenefitsListGrid';

export default function BenefitsListSection(): React.ReactElement {
  const bem = bemBlock('benefits-list-section');
  return (
    <PageSection variant="solid-neutral" className={bem()}>
      <BenefitsListGrid />
    </PageSection>
  );
}
